import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { Resolver } from "../concrete";

export interface IntentDialogData
{
    readonly resolvers: Array<Resolver>;
}

@Component({
    selector: "intent-dialog-component",
    templateUrl: "./intentDialog.tmpl.html",
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
    ]
})
export class IntentDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<IntentDialogComponent>>(MatDialogRef);
    private readonly data = inject<IntentDialogData>(MAT_DIALOG_DATA);

    readonly resolversGrid: ReadonlyArray<ReadonlyArray<Resolver>>;

    constructor()
    {
        this.resolversGrid = this.chuck(this.data.resolvers, 3);
    }

    onIntentClicked(resolver: Resolver): void
    {
        this.dialogRef.close(resolver);
    }

    private chuck(array: Array<Resolver>, size: number): Array<Array<Resolver>>
    {
        const newArr: Array<Array<Resolver>> = [];
        for (let i = 0; i < array.length; i += size)
        {
            newArr.push(array.slice(i, i + size));
        }
        return newArr;
    }
}
